import { render, staticRenderFns } from "./add-group.vue?vue&type=template&id=e2bcc028&"
import script from "./add-group.ts?vue&type=script&lang=js&"
export * from "./add-group.ts?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports